import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Box,
  Typography,
  Grid,
  Paper,
  Divider,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
} from '@mui/material';
import { investorApi } from '../../api/api'; 

const UserListPage = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch user data from API
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await investorApi.getAllUsers();
        const data = response.data.map((u) => ({
          name: u.Username,
          email: u.Email,
          contact: u.Mobilenumber,
          subscription: u.isSubscribed || 'Free',
          ownedProperties: u.owned_property_count || 0,
          projectCount: u.owned_project_count || 0,
          avatar: u.avatar?.trim(),
          PlanName:u.plan_name,
          purchasedProperties: u.purchasedProperties || [],
        }));
        setUsers(data);
      } catch (err) {
        console.error('Failed to fetch users:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" sx={{ mb: 4, fontWeight: 600, color: '#13216e' }}>
        All Users
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={3}>
          {users.map((user, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Paper elevation={3} sx={{ p: 3 }}>
                <Box display="flex" alignItems="center" mb={2}>
                  <Avatar
                    src={user.avatar}
                    alt={user.name}
                    sx={{ width: 80, height: 80, mr: 2 }}
                  />
                  <Box>
                    <Typography variant="h6" fontWeight="bold">
                      {user.name}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {user.email}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {user.contact}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Grid container spacing={2}>
                 <Grid
  item
  xs={12}
  sm={6}

>
  <Typography variant="subtitle2" color="text.secondary">
    Subscription
  </Typography>

  <Typography variant="body2">
    {user.PlanName || 'No'}
  </Typography>
</Grid>

                  <Grid item xs={6} sm={3}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Owned Properties
                    </Typography>
                    <Typography variant="body2">{user.ownedProperties}</Typography>
                  </Grid>
                  <Grid item xs={6} sm={3}>
                    <Typography variant="subtitle2" color="text.secondary">
                      Owned Projects
                    </Typography>
                    <Typography variant="body2">{user.projectCount}</Typography>
                  </Grid>
                </Grid>

                {user.purchasedProperties.length > 0 && (
                  <>
                    <Divider sx={{ my: 2 }} />
                    <Typography variant="subtitle1" gutterBottom>
                      Purchased Properties
                    </Typography>
                    <List dense>
                      {user.purchasedProperties.map((prop, i) => (
                        <ListItem key={i} disablePadding>
                          <ListItemText
                            primary={prop.name}
                            secondary={`Location: ${prop.location} | Date: ${prop.date} | Price: ${prop.price}`}
                          />
                        </ListItem>
                      ))}
                    </List>
                  </>
                )}
              </Paper>
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default UserListPage;
